import { createContext, useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import FbService from 'FB';
import AppService from 'app.service';
import { removeAppAuthToken, removeStoredAuthToken, removeTokenCode } from 'utils/auth';
import { useApp } from 'App';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthGuard = ({ children }) => {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export const AuthProvider = ({ children }) => {
  const app = useApp();
  const update = user => app.setUserData(user);
  const signin = async tokenCode => await AppService.appUserLogin(tokenCode);
  const signout = () => {
    // TODO: rest app state need to run after facebook logout.
    // current app state don't have user token after reloagin from storage data.
    // require fix the flow on non POC product.
    removeStoredAuthToken();
    removeAppAuthToken();
    removeTokenCode();
    app.resetAppState();
    FbService.logout();
  };

  let auth = { user: app.state.user, update, signin, signout };

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};
